import { useState, useEffect } from 'react'

import { LoginForm } from '@/features/auth/components'
import VersionInfo from '@/components/info'
import { getCleanDomain } from '@/utils/getCleanDomain'
import { hasSessionExpiredNotice } from '@/features/auth/utils/session-expired-notice'

export default function LoginPage() {
  const shouldSkipIntro = hasSessionExpiredNotice()

  const [showLogo, setShowLogo] = useState(!shouldSkipIntro)
  const [showLogin, setShowLogin] = useState(shouldSkipIntro)

  useEffect(() => {
    if (shouldSkipIntro) {
      setShowLogo(false)
      setShowLogin(true)
      return
    }

    const timer = setTimeout(() => {
      setShowLogo(false)
      setTimeout(() => setShowLogin(true), 500)
    }, 2000)

    return () => clearTimeout(timer)
  }, [shouldSkipIntro])

  const domain = getCleanDomain()

  let title
  if (domain === 'trisolution.com.br') {
    title = '/48762505000110.svg'
  // } else if (domain === 'mdtributaria.com.br') {
  //   title = '/46553339000116.svg'
  // } else if (domain === 'grupobahiasul.com.br') {
    // title = '/46151037000111.svg'
  } else if (domain === 'dsconsultoriat.com.br') {
    title = '/59754843000126.svg'
  } else {
    title = '/50734366000162.svg'
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-background to-secondary dark:from-background dark:to-gray-800 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br to-transparent"></div>
      {/* Contêiner principal */}
      <div className="relative w-full max-w-md">
        {/* Logo com animação */}
        <div
          className={`absolute inset-0 flex items-center justify-center transition-all duration-1000 ease-in-out ${
            showLogo ? 'opacity-100 scale-100 rotate-0' : 'opacity-0 scale-[5]'
          }`}
        >
          <img
            src={title} // Utilizando a variável title dinamicamente
            width={200}
            height={200}
            className="animate-pulse"
            aria-hidden="true"
            onError={e => {
              e.currentTarget.src = '/error-img.png' // Caminho para uma imagem padrão
            }}
          />
        </div>

        {/* Formulário de Login com transição */}
        <div
          className={`transition-all duration-1000 ease-in-out ${
            showLogin ? 'opacity-100 scale-100 translate-y-0' : 'opacity-0 scale-95 translate-y-10'
          }`}
        >
          {showLogin && <LoginForm />}
          <VersionInfo />
        </div>
      </div>
    </div>
  )
}
